import Vue from 'vue'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import Main from './application/Main.vue'

// Routes
Vue.use(VueRouter)

// I18n
Vue.use(VueI18n)

// App
document.addEventListener("DOMContentLoaded", () => {
  fetch("/api/collections/diamonds/translations.json")
  .then(response => response.json())
  .then(data => {
      const app = document.getElementById('app');
      const router = new VueRouter({
        base: 'collections/diamonds',
        mode: 'history',
      });
      const i18n = new VueI18n({
        locale: 'ja',
        messages: data.data,
      })

      new Vue({
        render: h => h(Main),
        router,
        i18n,
      }).$mount(app)
    });
})
